import React, { useEffect, useState } from "react";
import { Table, Button, Form } from "react-bootstrap";
import Layout from "../../components/Layout";
import { getEmployeeInvoiceLogs } from "../../api/TaskApi";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getEmployeeDetails } from "../../api/EmployeeApi";
import { useLocation, useNavigate } from "react-router-dom";
import { getTenantDetails } from "../../api/TenantApi";
import { getAllRoutebyContractor } from "../../api/RouteApi";
import { addInvoice } from "../../api/ReportApi";
import ToastFile from "../../utils/ToastFile";
import InvoicePDF from "../../components/InvoicePdf";
import Loader from "../../components/Loader";

const GenerateInvoice = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [employeeDetails, setEmployeeDetails] = useState({});
  const [tenantDetails, setTenantDetails] = useState({});
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const invoiceRef = React.useRef();
  const [routeOptions, setRouteOptions] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [pdfData, setPdfData] = useState([]);
  const [isTimeChecked, setIsTimeChecked] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [buttonIsLoading, setButtonIsLoading] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768); // change 768 to your breakpoint
    };

    checkMobile(); // check on load
    window.addEventListener("resize", checkMobile); // update on resize

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (user?.id) {
      setIsloading(true)
      getEmployeeDetails(user.id).then((res) => {
        if (res.status === 200) {
          setEmployeeDetails(res?.data?.data || {});
        }
      });
      getTenantDetails(user?.tenant_id).then((res) => {
        if (res.status === 200) {
          setTenantDetails(res?.data?.data || {});
        }
      });
      handleGenerate(state?.startDate, state?.endDate);
      getRoute();
    }
  }, [user?.id]);

  const getRoute = () => {
    getAllRoutebyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setRouteOptions(res?.data?.data?.routes);
        } else {
        }
      })
      .catch((err) => {
        console.error("Error fetching routes:", err);
      });
  };

  const handleGenerate = async (startDate, endDate) => {
    await getEmployeeInvoiceLogs(user?.id, startDate, endDate).then((res) => {
      setIsloading(false)
      if (res.status === 200) {
        setFilteredLogs(res.data.data.invoiceLogs);
      }
     })
    .catch((err)=>{
       setIsloading(false)
    })
  };

  // Calculate totals
  const totalClaimHours = filteredLogs?.reduce(
    (sum, log) => sum + (parseFloat(log.claimHours) || 0),
    0
  );
  const totalAmount = filteredLogs?.reduce(
    (sum, log) => sum + parseFloat(Number(log.totalCost ? log.totalCost : 0)),
    0
  );
  const totalAdditional = filteredLogs?.reduce(
    (sum, log) => sum + (parseFloat(Number(log.fuelCost)) || 0),
    0
  );

  const Total = totalAmount;

  const GST = 10.0;
  const GST_AMOUNT = Total / (1 + GST);

  const totalHousClaim = filteredLogs?.reduce(
    (sum, log) => sum + (log.claimHours < 15 ? parseFloat(log.claimHours) : 0),
    0
  );
  const totalParcel = filteredLogs?.reduce(
    (sum, log) => sum + (log.claimHours >= 15 ? parseFloat(log.claimHours) : 0),
    0
  );

  const handleSaveInvoice = async () => {
    setButtonIsLoading(true);
    let payload = {
      employee_id: user.id,
      invoiceNumber: employeeDetails?.name + moment().format("D-MMM-YYYY"),
      date: new Date(),
      startDate: new Date(state?.startDate),
      endDate: new Date(state?.endDate),
      companyName: tenantDetails.name,
      totalAmount: totalAmount.toFixed(2),
      GST: GST_AMOUNT.toFixed(2),
      tenant_id: user.tenant_id,
      createdBy: user.user_id,
      createdAt: new Date(),
    };
    addInvoice(payload)
      .then((res) => {
        setButtonIsLoading(false);
        if (res.status === 201) {
          // ToastFile("Invoice added successfully", "added");
          // setTimeout(() => {
          //   navigate("/invoice");
          // }, 2000);
          ConvertInvoiceDatapdf();
        } else {
          ToastFile("Failed to add invoice", "error");
        }
      })
      .catch((err) => {
        setButtonIsLoading(false);
        console.error("Error adding invoice:", err);
        ToastFile("Error adding invoice", "error");
      });

    // if(isMobile){
    //   handleDownloadMobilePDF()
    // }else{
    //   handleDownloadPDF()
    // }
  };

  const ConvertInvoiceDatapdf = () => {
    const rowdata = filteredLogs?.map((log, idx) => ({
      date: moment(log.date).format("D/M/YY"),
      category: log.category,
      route: log.routeInfo.map((item, index) => {
        const matched = routeOptions.find((el) => el._id === item);
        return (
          <span key={index}>
            {matched?.routeName}
            {index < log.routeInfo.length - 1 ? ", " : ""}
          </span>
        );
      }),
      start: moment(log.startTime).format("hh:mm a"),
      end: log.endTime ? moment(log.endTime).format("hh:mm a") : "",
      units: log.claimHours,
      rate: log.payrate,
      fuel: log.fuelCost,
      total: log.totalCost,
    }));

    const dataPdf = {
      invoiceDate: moment().format("D-MMM-YYYY"),
      invoiceNumber: employeeDetails?.name + moment().format("D-MMM-YYYY"),
      billFrom: {
        companyName: employeeDetails?.name,
        abn: employeeDetails?.abn,
        contact: employeeDetails?.contact_no,
        address: employeeDetails?.address,
      },
      billTo: {
        companyName: tenantDetails.name,
        abn: tenantDetails.abn,
        contact: tenantDetails.contact_no,
        address: tenantDetails.address,
      },
      rows: rowdata,
      gstPercent: GST,
      gstIncluded: `$${GST_AMOUNT.toFixed(2)}`,
      total: `$${Total.toFixed(2)}`,
      totalHousClaim: totalHousClaim,
      totalParcel: totalParcel,
    };
    setIsGeneratingPDF(true);
    setPdfData(dataPdf);
  };

  const handleChange = (event) => {
    setIsTimeChecked(event.target.checked);
  };

  return (
    <>
      {isGeneratingPDF ? (
        <InvoicePDF data={pdfData} isTimeChecked={isTimeChecked} />
      ) : (
        <Layout>
          <div>
            <div className="w-100">
              <div className="d-flex justify-content-end px-3">
                <label>
                  <input
                    type="checkbox"
                    checked={isTimeChecked}
                    onChange={handleChange}
                  />
                  {" "} Start & End Time
                </label>
              </div>
              <div
                ref={invoiceRef}
                className="w-100"
                style={{
                  border: "1px solid #ccc",
                  padding: 24,
                  background: "#fff",
                }}
              >
                <div
                  style={{ backgroundColor: "#e5e5dd" }}
                  className="mb-3 p-2"
                >
                  <div
                    className="d-flex justify-content-center"
                    style={{
                      minWidth: "100%",
                      maxWidth: "100%",
                      textAlign: "center",
                    }}
                  >
                    <span>
                      <b style={{ fontSize: 30 }}>TAX INVOICE</b>
                    </span>
                  </div>
                  <div
                    className="d-flex justify-content-end"
                    style={{
                      minWidth: "100%",
                      maxWidth: "100%",
                      textAlign: "right",
                    }}
                  >
                    <div className="d-flex flex-column">
                      <span>Date : {moment().format("D-MMM-YYYY")} </span>
                      <span>
                        Inv No:
                        {employeeDetails?.name + moment().format("D-MMM-YYYY")}
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex justify-content-between mb-3 p-2"
                  style={{
                    backgroundColor: "#e5e5dd",
                    minWidth: "100%",
                    maxWidth: "100%",
                  }}
                >
                  <div className="d-flex flex-column gap-3">
                    <div>
                      <b>Bill From:</b>
                    </div>
                    <div>
                      Company Name: {employeeDetails?.name || "Employee Name"}
                    </div>
                    <div>ABN: {employeeDetails?.abn || "-"}</div>
                    <div>Contact No: {employeeDetails?.contact_no || "-"}</div>
                    <div>Address: {employeeDetails?.address || "-"}</div>
                  </div>
                  <div className="d-flex flex-column gap-3">
                    <div>
                      <b>Bill To:</b>
                    </div>
                    <div>Company Name: {tenantDetails.name}</div>
                    <div>ABN: {tenantDetails.abn || "-"}</div>
                    <div>Contact No: {tenantDetails.contact_no || "-"}</div>
                    <div>Address: {tenantDetails.address || "-"}</div>
                  </div>
                </div>
                <Table bordered responsive size="sm">
                  <thead className="table-dark">
                    <tr style={{ textAlign: "center" }}>
                      <th>Date</th>
                      <th>Category</th>
                      <th>Route</th>
                      {isTimeChecked && (
                        <>
                          <th>Starting Time</th>
                          <th>Ending Time</th>
                        </>
                      )}
                      <th>Claim hours / No of Parcels</th>
                      <th>Pay Rate / Per Parcel Cost</th>
                      <th>Fuel Cost</th>
                      <th>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredLogs.length === 0 ? (
                      <tr>
                        <td
                          colSpan={isTimeChecked ? "9" : "7"}
                          className="text-center"
                        >
                          {isLoading ? <Loader /> : "No data"}
                        </td>
                      </tr>
                    ) : (
                      <>
                        {filteredLogs?.map((log, idx) => (
                          <tr key={idx}>
                            <td style={{ textAlign: "center" }}>
                              {moment(log.date).format("D/M/YY")}
                            </td>
                            <td>{log.category}</td>
                            <td>
                              {log.routeInfo.map((item, index) => {
                                const matched = routeOptions.find(
                                  (el) => el._id === item
                                );
                                return (
                                  <span key={index}>
                                    {matched?.routeName}
                                    {index < log.routeInfo.length - 1
                                      ? ", "
                                      : ""}
                                  </span>
                                );
                              })}
                            </td>
                            {isTimeChecked && <>
                            <td style={{ textAlign: "center" }}>
                              {moment(log.startTime).format("hh:mm a")}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {log.endTime
                                ? moment(log.endTime).format("hh:mm a")
                                : ""}
                            </td>
                            </>}
                            <td style={{ textAlign: "end" }}>
                              {log.claimHours}
                            </td>
                            <td style={{ textAlign: "end" }}>{log.payrate}</td>
                            <td style={{ textAlign: "end" }}>{log.fuelCost}</td>
                            <td style={{ textAlign: "end" }}>
                              {log.totalCost}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={isTimeChecked ? "8" : "6"}></td>
                          <td style={{ textAlign: "end" }}>
                            <b>{totalAmount.toFixed(2)}</b>
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
                {/* <div className="d-flex justify-content-end mb-3">
              <div style={{ width: "350px" }}>
                <Table size="sm" borderless>
                  <tbody>
                    <tr>
                      <td style={{ backgroundColor: "#e5e5dd" }}>
                        {selectedCategoryid === 1
                          ? `Total Claims hours / Numbers of Parcels`
                          : `Total Numbers of Units`}
                      </td>
                      <td>
                        <b>{totalClaimHours}</b>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: "#e5e5dd" }}>Pay Rate / Per Parcel Cost</td>
                      <td>${filteredLogs[0]?.payrate}</td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: "#e5e5dd" }}>
                        Total Amount (including GST)
                      </td>
                      <td style={{ backgroundColor: "#e5e5dd" }}>${totalAmount}</td>
                    </tr>
                    <tr>
                      <td style={{ height: 40 }}></td>
                    </tr>
                    <tr>
                      <td style={{ backgroundColor: "#e5e5dd" }}>Additional Cost</td>
                      <td style={{ backgroundColor: "#e5e5dd" }}>${totalAdditional.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ height: 40 }}></td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div> */}
                <div
                  className="d-flex justify-content-between p-2"
                  style={{ backgroundColor: "#e5e5dd" }}
                >
                  <div
                    style={{
                      width: "320px",
                      backgroundColor: "#e5e5dd",
                      borderRadius: "8px",
                    }}
                  >
                    <Table borderless className="m-0">
                      <tbody>
                        <tr>
                          <td style={{ backgroundColor: "#e5e5dd" }}>
                            Total hours claim
                          </td>
                          <td style={{ backgroundColor: "#e5e5dd" }}>
                            {totalHousClaim}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              backgroundColor: "#e5e5dd",
                              //  minWidth: "200px",
                            }}
                          >
                            Total Parcel
                          </td>
                          <td style={{ backgroundColor: "#e5e5dd" }}>
                            {totalParcel}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                  <div
                    style={{
                      width: "320px",
                      backgroundColor: "#e5e5dd",
                      //padding: "10px",
                      borderRadius: "8px", // optional: adds soft edges
                    }}
                  >
                    <Table borderless className="m-0">
                      <tbody>
                        <tr>
                          <td style={{ backgroundColor: "#e5e5dd" }}>GST %</td>
                          <td style={{ backgroundColor: "#e5e5dd" }}>{GST}</td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              backgroundColor: "#e5e5dd",
                              //  minWidth: "200px",
                            }}
                          >
                            GST Included
                          </td>
                          <td style={{ backgroundColor: "#e5e5dd" }}>
                            ${GST_AMOUNT.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ backgroundColor: "#e5e5dd" }}>
                            <b>Total</b>
                          </td>
                          <td style={{ backgroundColor: "#e5e5dd" }}>
                            <b>${Total.toFixed(2)}</b>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              {/* <div className="d-flex justify-content-center p-3">
            <div>
              <b>Notes:</b>
              <span>
                For any queries, please contact {employeeDetails.name} :{" "}
                {employeeDetails.contact_no}
              </span>
            </div>
          </div> */}
              <div className="d-flex justify-content-center gap-3">
                <Button
                  variant="dark"
                  className="mb-3 mt-2"
                  onClick={() => {
                    navigate("/invoice");
                  }}
                >
                  Go Back
                </Button>
                <Button
                  variant="success"
                  className="mb-3 mt-2"
                  onClick={handleSaveInvoice}
                  disabled={buttonIsLoading}
                >
                  {buttonIsLoading ? "Generating PDF..." : "Save & Download"}
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      )}
    </>
  );
};

export default GenerateInvoice;
